<template>
  <popup-bg :show-lock="showLock">
    <div slot="custom-html">
      <div class="returnvisit-wrap">
        <div class="popup-common-title">快速回访</div>
        <el-form :model="visitShadow" :hide-required-asterisk="true" label-width="24%" :rules="rules" ref="visitForm">
          <el-form-item
            label="方式"
            prop="visit_kind">
            <jm-dict-select
              clearable
              dict="dataset.visit.way"
              v-model="visitShadow.visit_kind"
            />
          </el-form-item>
          <el-form-item label="快捷记录">
            <jm-dict-select
              clearable
              dict="dataset.visit.quickRecord"
              v-model="visitShadow['record']"
              @change="quickFill"
            />
          </el-form-item>
          <el-form-item label="回访类型" :prop="($hasPermission(1) || isNormal) ? 'visit_type' : ''">
            <jm-dict-select
              :clearable="$hasPermission(1) || isNormal"
              dict="dataset.visit.type"
              v-model="visitShadow['visit_type']"
              :filter="visitTypeFilter"
            />
          </el-form-item>
          <el-form-item label="记录" prop="vist_str">
            <el-input
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请输入内容"
              v-model="visitShadow['vist_str']"/>
          </el-form-item>
          <div class="bluefire-common-btnarea">
            <el-button :loading="btnLock" @click="saveVisit('visitForm', '保存')" state-key="fib.jiemo.net/h5/common/visit-保存" :state-status="true">保存</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>

<script>
import popupBg from './popupBg';
import * as visitDataset from '@/dataset/visit';
import { mapGetters } from 'vuex';

const rules = {
  visit_kind: [
    {
      type: 'number', required: true, message: '请选择联系方式', trigger: 'blur'
    }
  ],
  visit_type: [
    {
      type: 'number', required: true, message: '请选择回访类型', trigger: 'blur'
    }
  ],
  vist_str: [
    { required: true, message: '请输入内容', trigger: 'blur' },
    { min: 10, message: '长度不能小于10个字符', trigger: 'blur' }
  ]
};

let visit = {
  visit_kind: null,
  record: '',
  visit_type: null,
  custom_hope_country: '',
  vist_str: '',
};

export default {
  data () {
    return {
      btnLock: false,
      visitShadow: {},
      rules
    };
  },
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    dataSet: {
      type: Object,
      default () {
        return {};
      }
    },
    operateVisit: {
      type: String,
      default: '',
    },
    crm_id: {
      type: Number,
      default: 0,
    },
    increaseType: { type: String, default: '' },
    crmLevelLv: { type: Number, default: 0 },
    crm_level: { type: Number, default: 0 },
  },
  computed: {
    ...mapGetters(['userInfo']), // this.userInfo
    isNormal() {
      return !this.$hasPermission([53]) // 待激活咨询
        && (
          this.userInfo.stations.indexOf(6) > -1
          || this.userInfo.stations.indexOf(10) > -1
          || this.$hasPermission([93, 52, 90, 109]) // 前程日本客户经理, 学生编辑组, 海外求职咨询, 海外求职技术类咨询
        );
    }
  },
  mounted() {
  },
  methods: {
    visitTypeFilter(item) {
      if (this.$hasPermission([91, 1, 98, 114])) {
        return true;
      }

      if (this.$hasPermission([117])) {
        if (item.value === 2 || item.value === 3) {
          return true;
        }
        return false;
      }

      if (this.isNormal) {
        if (item.value === 1 || item.value === 2) {
          return true;
        }
        return false;
      }

      if (item.value === 3) {
        return true;
      }
      return false;
    },
    quickFill(v) {
      visitDataset.quickRecord.forEach((item) => {
        if (item.value === v) {
          this.visitShadow.vist_str = item.label;
        }
      });
    },
    // 保存
    saveVisit(formName, title) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLock = true;
          console.log(this.crm_id);
          this.visitShadow.userid = this.crm_id;
          if (title === '资源激活') {
            this.visitShadow.isActivate = 1;
          }
          let urlList = {
            fib: '/index/visit/resource',
            training: '/training/visit/resource',
            job: '/job/visit/resource',
            fibOperate: '/index/operate_visit/resource', // 蓝火系统，用户运营回访
            trainingOperate: '/training/operate_visit/resource', // 星图系统，用户运营回访
            jobOperate: '/job/operate_visit/resource', // 星火系统，用户运营回访
          };
          let saveUrl = '';
          if (this.operateVisit !== '') {
            saveUrl = urlList[this.operateVisit] ? urlList[this.operateVisit] : urlList.fib;
          } else {
            saveUrl = urlList[this.$siteName] ? urlList[this.$siteName] : urlList.fib;
          }
          if (this.crm_level === 55 && this.visitShadow.visit_type !== 2) {
            return this.$message.error('请选择跟进型回访类型');
          }
          this.$http._post({
            url: saveUrl,
            data: this.visitShadow
          }).then(() => {
            this.btnLock = false;
            this.$emit('update:showLock', false);
            this.$message.success('保存成功');
            this.visitShadow = Object.assign({}, visit);
            // Object.keys(this.visitShadow).forEach((key) => {
            //   if (typeof this.visitShadow[key] !== 'object') {
            //     this.visitShadow[key] = '';
            //   }
            // });
            // window.location.reload();
          }).catch(() => {
            this.btnLock = false;
            this.$emit('update:showLock', false);
          });
        }
      });
    },
  },
  components: {
    'popup-bg': popupBg
  },
  watch: {
    showLock(v) {
      this.visitShadow = Object.assign({}, visit);
      if (v === false) {
        this.studentInfo = {};
      }
      if (this.dataSet.id) {
        this.visitShadow = Object.assign({}, visit, this.dataSet);
        this.visitShadow.crmid = this.dataSet.userid;
        // 以下代码方便编辑时赋值
        // 初始化visit_kind
        visitDataset.way.forEach((item) => {
          if (item.label === this.visitShadow.visit_kind) {
            this.visitShadow.visit_kind = item.value;
          }
        });
        // 初始化visit_type
        visitDataset.type.forEach((item) => {
          if (item.label === this.visitShadow.visit_type) {
            this.visitShadow.visit_type = item.value;
          }
        });
      }
    },
    // dataSet() {
    //   this.initVisitData();
    //   this.initUserInfo();
    // },
  }
};
</script>
<style>
  .returnvisit-wrap .el-form .el-form-item .jm-dict-select, .returnvisit-wrap .el-form .el-form-item .jm-dict-select .el-select{
    width: 100% !important;
  }
</style>
<style scoped>
  .returnvisit-wrap{
    padding: 0 4vw;
  }
  .returnvisit-wrap .el-form{
    margin-top: 0;
  }
  .returnvisit-wrap .el-form .el-form-item{
    margin-bottom: 2vw;
  }
  .returnvisit-wrap .el-select{
    width: 100%;
  }
</style>
